import { useLocation } from "react-router-dom";
import { defaultLanguage } from "@/i18n/config";
import { getSeoPath, getSeoLanguage } from "@/lib/seoRoutes";

/**
 * Hook to get localized paths for navigation
 * Returns a function that prepends the current language prefix to paths
 */
export const useLocalizedPath = () => {
  const location = useLocation();
  
  const currentLanguage = getSeoLanguage(location.pathname);

  /**
   * Get a localized path
   * @param path - The path to localize (e.g., "/expert-led-tours")
   * @returns The localized path (e.g., "/de/expert-led-tours" or "/expert-led-tours" for English)
   */
  const getPath = (path: string): string => {
    return getSeoPath(path, currentLanguage) + (path.match(/[?#].*$/)?.[0] || "");
  };

  /**
   * Get the home path for the current language
   */
  const homePath = currentLanguage === defaultLanguage ? "/" : `/${currentLanguage}`;

  return {
    getPath,
    homePath,
    currentLanguage,
  };
};

export default useLocalizedPath;
